<template>
    <div>
        <template v-if="activeUser">
            <div v-bind:style="{ backgroundImage: 'url(' + myCoverPhoto + ')' }" class="p-2 profile-wallpaper">
                <div class="row">
                    <!-- enable clicks from left to show banner on mobile view -->
                    <div @click="enlargeCover = true" class="col-sm-4 col-3 d-sm-none clickable"></div>
                    <div class="col-sm-4 col-6 offset-sm-4 text-center p-0">
                        <!-- users dp -->
                        <span @click="enlargeDp = true">
                            <img v-if="activeUser.dp" :src="myProfilePhoto" class="profile-photo clickable" 
                            :alt="`${activeUser.name}'s aNewItem profile`" 
                            :title="`@${activeUser.userHandle} profile - aNewItem`">
                            <i v-else class="fas fa-user-circle fa-7x"></i>
                        </span>
                    </div>
                    <div class="col-sm-4 col-3 d-sm-block d-none">
                        <div class="profile-cover-edit">
                            <span @click="enlargeCover = true" class="btn btn-dark btn-sm p-0 px-1"><i class="far fa-eye"></i> view</span>
                            <template v-if="authenticated && activeUser._id == user._id">
                                <span @click="changeCoverPhoto = true" class="btn btn-dark btn-sm p-0 px-1 ml-2"><i class="far fa-image"></i> change</span>
                            </template>
                        </div>
                    </div>
                    <!-- enable clicks from right to show banner on mobile view -->
                    <div @click="enlargeCover = true" class="col-sm-4 col-3 d-sm-none clickable"></div>
                </div>
                <!-- users handle -->
                <div class="row">
                    <div class="col-12 text-center">
                        <p v-if="activeUser.userHandle" class="text-center profile-handle">
                            {{activeUser.userHandle}}
                        </p>
                        <p v-else class="text-center profile-handle add-ellipsis">
                            {{activeUser.email}}
                        </p>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <!-- lazy load while items get fetched -->
            <app-account-holder></app-account-holder>
        </template>
        
        <!-- show change display photo -->
        <app-change-photo v-if="changeDisplayPhoto" kind="display"></app-change-photo>
        
        <!-- show change cover photo -->
        <app-change-photo v-if="changeCoverPhoto" kind="cover"></app-change-photo>

        <!-- enlarge the user cover photo if requested -->
        <app-view-photo v-if="enlargeCover" @closePhoto="hideEnlargedPhoto" :photo="myCoverPhoto"></app-view-photo>
        
        <!-- enlarge the user display photo if requested -->
        <app-view-photo v-if="enlargeDp" @closePhoto="hideEnlargedPhoto" :photo="myProfilePhoto"></app-view-photo>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { appendImgHostUrl, webpageTitle, capitalizeWord } from '@/store/dry'
import { eventBus } from '@/main'

import ChangePhoto from '../pages/settingsParts/ChangePhoto.vue'
import GhostMode from '@/components/general/shared/GhostMode.vue'
import ViewPhoto from '@/components/general/shared/ViewPhoto.vue'
import AccountHolder from './accountParts/AccountHolder.vue'

export default {
    name: "Account",
    data() {
        return {
            changeDisplayPhoto: false,
            changeCoverPhoto: false,
            enlargeCover: false,
            enlargeDp: false,
        }
    },
    methods: {
        hideEnlargedPhoto() {
            this.enlargeCover = false
            this.enlargeDp = false
        },
    },
    computed: {
        ...mapGetters(['authenticated', 'user']),
        myProfilePhoto() {
            webpageTitle(`
                ${capitalizeWord(this.activeUser.name)} 
                (@${this.activeUser.userHandle})
            `)
            let dp = this.activeUser.dp
            return appendImgHostUrl(dp)
        },
        myCoverPhoto() {
            let cover = this.activeUser.cover
            return appendImgHostUrl(cover)
        },
        activeUser() {
            if(this.user !== null){
                return this.user
            }
            return false
        },
    },
    components: {
        appChangePhoto: ChangePhoto,
        appGhostMode: GhostMode,
        appViewPhoto: ViewPhoto,
        appAccountHolder: AccountHolder
    },
    created() {
        eventBus.$on('hideGhostMode', (value) => {
            this.changeCoverPhoto = value;
            this.changeDisplayPhoto = value;
        })
    }
}
</script>